export async function getRequestHeader() {
  return new Promise((resolve) => {
    // 1️⃣ 尝试从 App Bridge 获取（常见方式）
    if (window.AppBridge && window.AppBridge.getHeader) {
      try {
        window.AppBridge.getHeader((res) => {
          resolve(normalize(res))
        })
        return
      } catch (e) {
        console.error('AppBridge 调用失败', e)
      }
    }

    // 2️⃣ 尝试 window 上的全局变量（有些 App 会注入）
    if (window.__APP_HEADER__) {
      resolve(normalize(window.__APP_HEADER__))
      return
    }

    // 3️⃣ 从 localStorage 取
    const local = localStorage.getItem('APP_HEADER')
    if (local) {
      resolve(normalize(local))
      return
    }

    // 4️⃣ 从 URL 取参数
    const urlParams = getParamsFromUrl()
    if (Object.keys(urlParams).length) {
      resolve(normalize(urlParams))
      return
    }

    // 5️⃣ 最后兜底
    resolve({})
  })
}

function normalize(data) {
  if (!data) return {}

  // 如果是字符串 → 转对象
  if (typeof data === 'string') {
    try {
      return JSON.parse(data)
    } catch (e) {
      console.error('header 解析失败', e)
      return {}
    }
  }

  return data
}


function getParamsFromUrl() {
  const search = window.location.search.slice(1)
  const params = {}

  search.split('&').forEach(item => {
    const [key, value] = item.split('=')
    if (key) {
      params[key] = decodeURIComponent(value || '')
    }
  })

  return params
}
